import { motion } from "framer-motion";

const variants = { hidden: { y: "112%" }, visible: { y: "0%" } };

const RevealLine = ({ children, delay = 0, className = "", inView = false, testid }) => (
  <motion.span
    className="block overflow-hidden"
    initial="hidden"
    {...(inView ? { whileInView: "visible", viewport: { once: true, margin: "-60px" } } : { animate: "visible" })}
  >
    <motion.span
      data-testid={testid}
      className={`block ${className}`}
      variants={variants}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export default RevealLine;
